var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationCity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.54-129.85v-464H356v-122.77L480-836l124 119.38v266.77h130.46v320H225.54Zm32-32h112v-112h-112v112Zm0-144h112v-112h-112v112Zm0-144h112v-112h-112v112Zm166.46 288h112v-112H424v112Zm0-144h112v-112H424v112Zm0-144h112v-112H424v112Zm0-144h112v-112H424v112Zm166.46 432h112v-112h-112v112Zm0-144h112v-112h-112v112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCity);
export default __webpack_public_path__ + "static/media/location_city.77ed52fc70c5a24d3ee36361e6acbb51.svg";
export { ForwardRef as ReactComponent };